import {ClientClientBrowsingHistoriesState} from "../store/client_client_browsing_histories_state";
import {Reducer} from "redux";
import {
    ClientClientBrowsingHistoriesAction,
    ClientClientBrowsingHistoriesActionType,
    ICallbackGetAllClientBrowsingHistoriesAction
} from "../action/client_client_browsing_histories_action";

const initialState: ClientClientBrowsingHistoriesState = {
    clientBrowsingHistories: [],
    customerCount: 0,
    customers: [],
    jobCareersWithCustomerID: [],
    clientBookmarks: [],
    isLoading: false,
};

const clientClientBrowsingHistoriesReducer: Reducer<ClientClientBrowsingHistoriesState> = (state = initialState, action: ClientClientBrowsingHistoriesAction): ClientClientBrowsingHistoriesState => {
    switch (action.type) {
        case ClientClientBrowsingHistoriesActionType.REQUEST_GET_ALL_CLIENT_BROWSINGHISTORIES: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientClientBrowsingHistoriesActionType.CALLBACK_GET_ALL_CLIENT_BROWSINGHISTORIES: {
            const _action = action as ICallbackGetAllClientBrowsingHistoriesAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    isLoading: false,
                    clientBrowsingHistories: _action.item ? _action.item.clientBrowsingHistories : [],
                    customerCount: _action.item ? _action.item.customerCount: 0,
                    customers: _action.item ? _action.item.customers : [],
                    clientBookmarks: _action.item ? _action.item.clientBookmarks: [],
                    jobCareersWithCustomerID: _action.item ? _action.item.jobCareersWithCustomerID : [],
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }
        default:
            return state;
    }

};

export default clientClientBrowsingHistoriesReducer;


// WEBPACK FOOTER //
// ./src/presentation/reducer/client_client_browsing_histories_reducer.ts